import React from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';

import { Store } from '../../store/reducers/reducers';
import FetchState from '../../utils/FetchState';
import Fetch from './Fetch';

export interface ConnectFetchParameter {
  fetchStateSelector: (store: Store) => FetchState | undefined;
  dataFetcherAction: (fetchState: FetchState | undefined) => AnyAction;
}

interface OwnProps {
  params: ConnectFetchParameter[];
  children?: React.ReactNode;
  render?: (props: { fetchStates: (FetchState | undefined)[] }) => JSX.Element;
}

interface DispatchProps {
  onFetchDataActions: ((fetchState: FetchState | undefined) => void)[];
}

interface StateProps {
  fetchStates: (FetchState | undefined)[];
}

interface Props extends OwnProps, StateProps, DispatchProps {}

function FetchContainer(props: Props) {
  const { params, ...others } = props;
  return <Fetch {...others} />;
}

const mapStateToProps = (store: Store, { params }: OwnProps): StateProps => ({
  fetchStates: params.map(({ fetchStateSelector }) => fetchStateSelector(store)),
});

const mapDispatchToProps = (dispatch: Dispatch, { params }: OwnProps): DispatchProps => ({
  onFetchDataActions: params.map(
    ({ dataFetcherAction }) =>
      (fetchState) =>
        dispatch(dataFetcherAction(fetchState))
  ),
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(FetchContainer);
